import { Component, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from "@angular/core";
import { FormControl } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, map, startWith, switchMap, tap } from 'rxjs/operators';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
export interface OptionChoose{
  id: number;
  text: string;
}
@Component({
  selector: 'asc-autocomplete',
  templateUrl: './select-autocomplete.component.html',
  styleUrls: ['./select-autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectAutocompleteComponent),
      multi: true
    }
  ]
})
export class SelectAutocompleteComponent implements  ControlValueAccessor, OnInit {
  @Input() set getListAC(value: (value: any) => Observable<any>){
    this._getListAC = value;
    if (this._getListAC){
      this.initObservation();
    }
  }
  writeValue(obj: any) {
  }

  registerOnChange(fn: any) {
  }

  registerOnTouched(fn: any) {
  }

  setDisabledState(isDisabled: boolean) {
  }
  // tslint:disable-next-line: member-ordering
  private _getListAC: (value: any) => Observable<any>;
  // tslint:disable-next-line: adjacent-overload-signatures
  get getListAC(){
    return this._getListAC;
  }
  selectedValue: string;
  @Input() label: string;
  @Input() formControlName: string;
  @Input() placeholder: string;
  @Input() required: boolean;
  @Input() readonly: string;
  @Input() valueChange: any;
  @Input() disabled: boolean;
  @Input() autocomplete: boolean;
  @Input() formControl: FormControl;
  @Input() ascModel: FormControl;
  @Output() ascModelChange = new EventEmitter<FormControl>();
  @Output() changeControl = new EventEmitter<any>();
  @ViewChild('input') input: ElementRef;
  value: any;
  listObservable: Observable<any>;
  isLoading = false;
  selectedId: any;
  nzOptions = null;
  searchChange$ = new BehaviorSubject('');
  buttonIsShow = () => this.ascModel.value != null && this.ascModel.value !== '' && this.ascModel.value.id != null;
  ngOnInit(): void { 
    if (!this.placeholder) { this.placeholder = ''; }
    if (this._getListAC) { this.initObservation(); }
  }
  ngOnChanges(){
    this.value = this.valueChange;
    this.ascModel.setValue(this.valueChange);
  }
  displayFn = (o1: any, o2: any) => (o1 && o2 ? o1.id === o2.id : o1 === o2);
  optionSelected(event) {
    this.value = event;
    this.ascModel.patchValue(this.value);
    this.ascModelChange.emit(this.ascModel);
  }

  instanceOfSeleted(data: any): data is OptionChoose {
    return 'text' in data;
  }
  onSearch(event: any){
    if (event !== '' && event !== null) {
      this.ascModel.setValue(event);
    }
  }
  initObservation() {
    this.listObservable = this.ascModel.valueChanges.pipe(
      startWith(''),
      tap(() => {
        this.isLoading = true;
      }),
      map(value => typeof value === 'string' ? value : ''),
      switchMap(value => this._getListAC(value)
        .pipe(
          map(resp => resp),
          finalize(() => {
            this.value = this.ascModel.value;
            setTimeout(() => {
              this.isLoading = false;
            }, 300);
          })
        )
      )
    );

  }
}
